import { ContentHeader, MainContentArea } from "melco-ui";
import { useParams } from "react-router-dom";
import { useUser } from "../../hooks/users/useUser";
import { UserDetailMoreActionButton } from "../../components/users/UserDetailMoreActionButton";
import { useTranslation } from "react-i18next";
import { useGenericDrawer } from "../../hooks/drawer/useGenericDrawer";
import { UserDetailProfileButton } from "../../components/users/UserDetailProfileButton";
import { UserProductsButton } from "../../components/users/UserProductsButton";

import { useState } from "react";
import { UserDetailProfileDrawer } from "../../components/users/drawer/UserDetailProfileDrawer";
import { UserDetailEditProfileDrawer } from "../../components/users/drawer/UserDetailEditProfileDrawer";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { useUserProductsData } from "../../hooks/users/useUserProductsData";
import { UserDetailForm } from "../../components/users/form/UserDetailForm";
import { UserEditProfileButton } from "../../components/users/UserEditProfileButton";
import { MASTER, SUB_USER } from "../../helper/usersHelper";

export const UserDetails: React.FC = () => {

  const { t } = useTranslation();
  const { userId } = useParams<{
    userId: string;
  }>();

  const {
    query: { data: user, refetch: refetchUser },
    queryKey
  } = useUser(
    userId ?? "",
  );

  const { data: userProducts, refetch } = useUserProductsData(userId);
  const referencesProductDrawer = useGenericDrawer();
  const [isEditProfileDrawerOpen, setIsEditProfileDrawerOpen] = useState(false);
  const [isUserProfileDrawerOpen, setIsUserProfileDrawerOpen] = useState(false);

  const { roles } = useRolesContext();
  const parent_user_id = user?.parent_user_id ?? "";
  const masterOrSubUser = parent_user_id === "" ? MASTER : SUB_USER;
  const userFirstName = user?.first_name ?? "";
  const userLastName = user?.last_name ?? "";
  const selectedUserId = userId ?? "";


  const setProductsDrawerAction = () => {
    refetch()

    const { closeDrawer } = referencesProductDrawer;
    closeDrawer()


  }

  const setIsEditProfileDrawerOpenAction = (v: boolean) => {
    setIsEditProfileDrawerOpen(v);
  }

  const setIsUserProfileDrawerOpenAction = (v: boolean) => {
    setIsUserProfileDrawerOpen(v);
  }

  const closeAllDrawerAction = () => {
    setIsEditProfileDrawerOpen(false);
    setIsUserProfileDrawerOpen(false);
    refetchUser();

  }





  return (
    <MainContentArea
      header={
        <ContentHeader
          title={
            <div>
              <div>{t("main_menu.users")}</div><br />
              <div>{userFirstName} {userLastName} [{masterOrSubUser}]</div>
            </div>}

          extra={
            <>
              {
                user && roles.USERS_MANAGE_PRODUCTS && (<UserProductsButton

                  referencesDrawer={referencesProductDrawer}

                />)
              }
              {
                user && (<UserDetailProfileButton

                  setIsUserProfileDrawerOpenAction={setIsUserProfileDrawerOpenAction}

                />)
              }
              {
                user && roles.USERS_EDIT && (<UserEditProfileButton

                  setIsEditProfileDrawerOpenAction={setIsEditProfileDrawerOpenAction}

                />)
              }
              {user && (roles.USERS_UNLOCK || roles.USERS_DISABLE) && (
                <UserDetailMoreActionButton
                  user={user}
                />
              )}
            </>
          }
        />
      }
      contentPadding
    >

      {userProducts && (
        <>
          <UserDetailForm
            userProducts={userProducts}
            onCloseProductsDrawer={setProductsDrawerAction}
            referencesProductDrawer={referencesProductDrawer!}
            selectedUserId={selectedUserId}
            refetch={refetch}
          />
        </>)

      }

      {
        isUserProfileDrawerOpen && user && (<UserDetailProfileDrawer
          user={user}
          closeAllDrawerAction={closeAllDrawerAction}
          isUserProfileDrawerOpen={isUserProfileDrawerOpen}

        />)
      }


      {
        isEditProfileDrawerOpen && user && (<UserDetailEditProfileDrawer
          user={user}
          closeAllDrawerAction={closeAllDrawerAction}
          isEditProfileDrawerOpen={isEditProfileDrawerOpen}
          queryKey={queryKey}
        />)
      }

    </MainContentArea>
  );
}